export default __webpack_public_path__ + "assets/gold-ea6c9bf65ad732c7859ee2a9ac47d8c0.svg";